import React from 'react';
import { useDispatch } from 'react-redux';

import { IconPlus } from '../../../assets/icon';
import Text from '../../../components/Text/Text';
import { toggleRelatedArticleListingModal } from '../../../actions/application/application';

const relatedBlockClassName = [
  'flex flex-1 flex-row items-center justify-center',
  'bg-primary-light border border-dashed border-primary rounded-[5px]',
  'px-[23px] py-[20px] cursor-pointer'
].join(' ');
const textBlockClassName = 'ml-[20px]';
const titleClassName = 'text-[16px]';
const subtitleClassName = 'mr-[3px]';

const EmptyRelatedBlock = () => {
  const dispatch = useDispatch();
  return (
    <div
      className={relatedBlockClassName}
      role="presentation"
      onClick={() => dispatch(toggleRelatedArticleListingModal())}
    >
      <IconPlus width={40} height={40} color="#009EF7FF" />
      <div className={textBlockClassName}>
        <Text text="Add related listing" bold textStyle={titleClassName} />
        <div className="flex flex-row">
          <Text text="Select products related by" muted textStyle={subtitleClassName} />
          <Text text="car,brand, category" bold />
        </div>
      </div>
    </div>
  );
};

EmptyRelatedBlock.propTypes = {};

EmptyRelatedBlock.defaultProps = {};

export default EmptyRelatedBlock;
